// #3 Tratativa de Denúncias (FP-CMP-004) — registro do recebimento + decisão de
// triagem. O "resumo do relato" (conteúdo cifrado) fica manual.

import type { FormBlock } from './form-pdf.js';
import { manualField } from './form-pdf.js';
import {
  type FormInput,
  categoriaLabel,
  competenciaLabel,
  gravidadeLabel,
  rotaLabel,
  fmtDate,
  memberLabel,
  getTriagem,
  getOpenedAt,
} from './forms-common.js';

export function buildTratativa(input: FormInput): FormBlock[] {
  const triagem = getTriagem(input.state);
  const openedAt = getOpenedAt(input.state);

  return [
    { kind: 'title', text: 'Tratativa de Denúncias' },
    { kind: 'section', text: 'Recebimento' },
    { kind: 'field', label: 'Protocolo:', value: input.caseId },
    { kind: 'field', label: 'Categoria:', value: categoriaLabel(input.categoria) },
    { kind: 'field', label: 'Comitê de competência:', value: competenciaLabel(input.categoria) },
    {
      kind: 'field',
      label: 'Data de recebimento:',
      value: openedAt === null ? '' : fmtDate(openedAt),
    },
    {
      kind: 'field',
      label: 'Canal de recebimento:',
      value: 'Canal de Denúncias (formulário web)',
    },
    { kind: 'section', text: 'Triagem' },
    { kind: 'field', label: 'Classificação de risco:', value: gravidadeLabel(triagem?.gravidade) },
    { kind: 'field', label: 'Rota do comitê:', value: rotaLabel(triagem?.rota) },
    {
      kind: 'field',
      label: 'Decisão de triagem:',
      value: triagem ? 'Instaurar investigação' : '',
    },
    {
      kind: 'field',
      label: 'Responsável pela triagem:',
      value: triagem ? memberLabel(input.members, triagem.classifiedBy) : '',
    },
    { kind: 'section', text: 'Relato' },
    manualField('Resumo do relato:'),
    { kind: 'spacer', mm: 6 },
    { kind: 'signature', nome: '', papel: 'Responsável pela tratativa' },
  ];
}
